import * as React from "react";

const headerTemplate = (props) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: "transparent",
        padding: "10px 0 0 0",
        zIndex: "2"
      }}
    >
      <div style={{ textAlign: "center" }}>
        <img
          src={require("Assets/img/tsga-letterhead-logo.png")}
          alt="Tarun Sardesai Golf Academy"
          style={{ width: "120px", height: "auto" }}
        />
      </div>
      <div
        style={{
          margin: "8px 20px 0 20px",
          borderBottom: "1.5px solid #A4C22E",
        }}
      />
    </div>
  );
};

export default headerTemplate;
